import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { Item } from '../../../core/components/listbox/listbox.component';

@Component({
  selector: 'tt-check-list-datas',
  templateUrl: './check-list-datas.component.html',
  styleUrls: ['./check-list-datas.component.css']
})
export class CheckListDatasComponent implements OnInit {
    argType;

    argValue;

    public itemsListCheckListDatas: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.argType = this.stateService.getStateParams()['argtype'];
        this.argValue = this.stateService.getStateParams()['argvalue'];
    }

    private async loadCheckListDatas() {
        if (!!this.argType && !!this.argValue) {
            this.itemsListCheckListDatas = await this.datatask.Post(230, {
                argtype: this.argType,
                argvalue: this.argValue
            });
        }
    }

    public goToFunc(state: any) {
        switch (state) {
            case 'selectchecklistadd':
                this.stateService?.go('selectchecklistadd', {
                    argtype: this.argType,
                    argvalue: this.argValue
                });
                break;
            default:
                break;
        }
    }

    private async init() {
        this.loadCheckListDatas();
    }

    ngOnInit() {
        this.init();
    }
}
